import { render, staticRenderFns } from "./splitTest.vue?vue&type=template&id=336609ee&scoped=true&"
import script from "./splitTest.vue?vue&type=script&lang=js&"
export * from "./splitTest.vue?vue&type=script&lang=js&"
import style0 from "./splitTest.vue?vue&type=style&index=0&id=336609ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336609ee",
  null
  
)

export default component.exports